
<iframe
  :id="content.fichierHtml['@path']"
  class="w-100 vh-100"
  :title="content.fichierHtml['@name']"
  :src="jel_getFichierSrc(content.fichierHtml)"
  frameborder="0"
  scrolling="no"
/>
